import { Box, Container, Grid, Paper, Stack, Typography } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

interface Persona {
  role: string;
  description: string;
}

// Honest "who this is built for" copy — no fabricated customer names,
// quotes, or testimonials (there is no real customer data to show yet).
const PERSONAS: Persona[] = [
  {
    role: "Retail Investor",
    description:
      "Wants AI-assisted market research and a portfolio view alongside their existing broker, without switching platforms.",
  },
  {
    role: "Portfolio-Focused Investor",
    description:
      "Tracks holdings and open-interest signals in one place instead of juggling separate broker apps and spreadsheets.",
  },
  {
    role: "Systematic Trader",
    description:
      "Wants to review a strategy's historical performance and risk profile, then deploy it directly through their own broker account.",
  },
];

export function TestimonialsSection() {
  return (
    <Box sx={{ py: { xs: 10, md: 14 } }}>
      <Container maxWidth="lg">
        <Box textAlign="center" maxWidth={560} mx="auto" mb={8}>
          <Typography variant="h4" fontWeight={800} mb={2}>
            Built for investors like you
          </Typography>
          <Typography variant="body2" color="text.secondary">
            TekStar Invest is designed around a few common ways people actually work.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {PERSONAS.map((persona) => (
            <Grid item xs={12} md={4} key={persona.role}>
              <Paper variant="outlined" sx={{ p: 3.5, height: "100%", borderRadius: 3 }}>
                <Stack direction="row" spacing={1.5} alignItems="center" mb={2}>
                  <PersonOutlineIcon sx={{ color: "primary.main" }} />
                  <Typography variant="subtitle1" fontWeight={700}>
                    {persona.role}
                  </Typography>
                </Stack>
                <Typography variant="body2" color="text.secondary">
                  {persona.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default TestimonialsSection;
